import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { motion } from 'framer-motion';
const ContactForm = () => {
  const [showPopup, setShowPopup] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_123',      // ✅ Replace with your actual service ID
        'template_do2c5ud', // ✅ Replace with your actual template ID
        e.target,
        '6PxTTnbfZfzUZhuLT' // ✅ Replace with your public key
      )
      .then(() => {
        setShowPopup(true);
        e.target.reset();
        setTimeout(() => setShowPopup(false), 3000);
      })
      .catch((error) => {
        console.error('EmailJS Error:', error);
        alert('Failed to send message. Please try again.');
      });
  };

  const mapEmbedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3445.123456789!2d71.123456!3d29.123456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x123456789abcdef%3A0x123456789abcdef!2sCP28%2B2WG%20Riaz%20ul%20jannah%2C%20New%20Satellite%20Town%2C%20Bahawalpur%2C%2063100%2C%20Pakistan!5e0!3m2!1sen!2s!4v1234567890123";

  return (
    <section className="relative w-full bg-gradient-to-br from-white via-gray-50 to-white py-20 px-4 sm:px-6 lg:px-8 overflow-hidden font-roboto">
      {/* Animated background orbs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-200/40 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-rose-200/40 rounded-full blur-3xl animate-pulse delay-1000" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-red-100/30 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* New heading */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-bold">
            <span className="bg-gradient-to-r from-red-600 via-red-500 to-rose-500 bg-clip-text text-transparent">
              Let’s Connect
            </span>
          </h2>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto text-lg">
            Have a project in mind or just want to say hello? We’d love to hear from you.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Left Card – Map & Contact Details */}
          <div className="group relative bg-white/60 backdrop-blur-md rounded-2xl p-6 transition-all duration-500 hover:bg-white/80 hover:shadow-2xl hover:shadow-red-200/40 border border-white/10 hover:border-red-300/50 h-full flex flex-col">
            <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-red-500/0 via-rose-500/0 to-red-500/0 group-hover:from-red-500/10 group-hover:via-rose-500/10 group-hover:to-red-500/10 transition-all duration-500" />
            <div className="relative z-10">
              <div className="w-full h-64 rounded-xl overflow-hidden mb-6 shadow-lg border border-white/30">
                <iframe
                  title="Ub Soft Office Location"
                  src={mapEmbedUrl}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="w-full h-full"
                />
              </div>

              <div className="flex-grow">
                <h2 className="text-gray-800 text-4xl sm:text-5xl font-bold mb-6 drop-shadow-sm">
                  Contact us
                </h2>
                <div className="space-y-4">
                  <div className="flex items-center text-gray-700">
                    <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mr-4 text-xl">
                      📞
                    </div>
                    <a href="tel:+92 300 1381308" className="text-base sm:text-lg font-medium hover:text-red-600 transition">
                      +92 300 1381308
                    </a>
                  </div>
                  <div className="flex items-center text-gray-700">
                    <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mr-4 text-xl">
                      📧
                    </div>
                    <a href="mailto:contact@ubisoftpvtltd.com" className="text-base sm:text-lg font-medium hover:text-red-600 transition">
                     ubcreationspvtltd@gmail.com
                    </a>
                  </div>
                  <div className="flex items-start text-gray-700">
                    <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mr-4 text-xl mt-1">
                      📍
                    </div>
                    <span className="text-base sm:text-lg font-medium">
                      Plot Number 2, Riaz ul jannah, Bahawalpur, Pakistan, 63100
                    </span>
                  </div>
                </div>
              </div>

              <div className="mt-6 text-gray-500 text-sm italic border-t border-red-200/30 pt-4">
                ✦ We typically respond within 24 hours ✦
              </div>
            </div>
          </div>

          {/* Right Card – Contact Form */}
          <div className="group relative bg-white/60 backdrop-blur-md rounded-2xl p-8 lg:p-11 transition-all duration-500 hover:bg-white/80 hover:shadow-2xl hover:shadow-red-200/40 border border-white/10 hover:border-red-300/50">
            <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-red-500/0 via-rose-500/0 to-red-500/0 group-hover:from-red-500/10 group-hover:via-rose-500/10 group-hover:to-red-500/10 transition-all duration-500" />
            <div className="relative z-10">
              <h2 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-red-600 via-red-500 to-rose-500 bg-clip-text text-transparent mb-6">
                Send Us A Message
              </h2>

              <form onSubmit={handleSubmit} className="space-y-5">
                <input
                  type="text"
                  name="name"
                  className="w-full h-12 text-gray-800 placeholder-gray-500 bg-white/80 backdrop-blur-sm text-base font-normal rounded-xl border border-gray-200 focus:border-red-400 focus:ring-2 focus:ring-red-300 outline-none px-4 transition-all"
                  placeholder="Your Name"
                  required
                />
                <input
                  type="email"
                  name="email"
                  className="w-full h-12 text-gray-800 placeholder-gray-500 bg-white/80 backdrop-blur-sm text-base font-normal rounded-xl border border-gray-200 focus:border-red-400 focus:ring-2 focus:ring-red-300 outline-none px-4 transition-all"
                  placeholder="Email Address"
                  required
                />
                <input
                  type="text"
                  name="phone"
                  className="w-full h-12 text-gray-800 placeholder-gray-500 bg-white/80 backdrop-blur-sm text-base font-normal rounded-xl border border-gray-200 focus:border-red-400 focus:ring-2 focus:ring-red-300 outline-none px-4 transition-all"
                  placeholder="Phone Number (optional)"
                />
                <textarea
                  name="message"
                  rows="4"
                  className="w-full text-gray-800 placeholder-gray-500 bg-white/80 backdrop-blur-sm text-base font-normal rounded-xl border border-gray-200 focus:border-red-400 focus:ring-2 focus:ring-red-300 outline-none p-4 transition-all"
                  placeholder="Your Message"
                  required
                />

                <button
                  type="submit"
                  className="w-full h-12 text-white text-base font-bold rounded-xl transition-all duration-300 bg-gradient-to-r from-red-600 to-rose-600 hover:from-red-700 hover:to-rose-700 shadow-md hover:shadow-lg hover:scale-[1.02] active:scale-[0.98] border border-white/20"
                >
                  Send Message
                </button>

                {showPopup && (
                  <div className="bg-green-100 border-2 border-green-400 text-green-800 px-4 py-3 rounded-xl text-center font-semibold shadow-lg">
                    ✅ Your message has been sent successfully!
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;